(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("photos", [], factory);
	else if(typeof exports === 'object')
		exports["photos"] = factory();
	else
		root["photos"] = factory();
})(this, () => {
return 